"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Component(fn) {
    return fn;
}
exports.default = Component;
//# sourceMappingURL=component.js.map